import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
    selector: 'lib-settings-modal-tw',
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './settingsModalTW.component.html',
    styleUrl: './settingsModalTW.component.scss'
})
export class SettingsModalTWComponent {
  @Input() isOpen = false;
  @Input() monthlyBudget: number = 0;
  
  @Output() save = new EventEmitter<{ monthlyBudget: number }>();
  @Output() cancel = new EventEmitter<void>();

  settingsForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.settingsForm = this.fb.group({
      monthlyBudget: [0, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnChanges() {
    if (this.monthlyBudget) {
      this.settingsForm.patchValue({ monthlyBudget: this.monthlyBudget });
    }
  }

  onSubmit(): void {
    if (this.settingsForm.valid) {
      this.save.emit(this.settingsForm.value);
    }
  }
}